import { cn } from '@/lib/utils'

/**
 * Figma (node 65:452):
 * Track: h-1 (4px), rounded-full (9999px), overflow-clip, bg = white/80 over primary (≈ bg-primary/20)
 * Fill: bg-primary (#171717), absolute inset-0 (width controlled by percent)
 * Variants: 0%, 25%, 50%, 75%, 100%
 */
export interface IntuiProgressProps {
  value?: number
  max?: number
  indeterminate?: boolean
  label?: string
  showValue?: boolean
  size?: 'sm' | 'default' | 'lg'
  className?: string
}

const sizeClasses = { sm: 'h-0.5', default: 'h-1', lg: 'h-2' }

function IntuiProgress({ value = 0, max = 100, indeterminate, label, showValue, size = 'default', className }: IntuiProgressProps) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100)

  return (
    <div className={cn('w-full', className)} role="progressbar" aria-valuenow={indeterminate ? undefined : value} aria-valuemin={0} aria-valuemax={max} aria-label={label ?? 'Progress'}>
      {(label || showValue) && (
        <div className="flex justify-between mb-1">
          {label && <span className="text-sm text-muted-foreground">{label}</span>}
          {showValue && !indeterminate && <span className="text-sm text-muted-foreground">{Math.round(percentage)}%</span>}
        </div>
      )}
      <div className={cn('w-full overflow-clip rounded-full bg-primary/20', sizeClasses[size])}>
        <div
          className={cn('h-full rounded-full bg-primary transition-all duration-300 ease-in-out', indeterminate && 'animate-pulse w-full')}
          style={indeterminate ? undefined : { width: `${percentage}%` }}
        />
      </div>
    </div>
  )
}

export { IntuiProgress }
